import React from 'react';

import Form from 'components/Form';
import { FormContain } from './Styled';
import { password, passwordConfirm } from './validation';

export const RegisterForm = ({ errors = [], onSubmit }) => {
  return (
    <FormContain>
      <Form.Fields
        errors={errors}
        renderSubmit={submitForm => (
          <Form.Submit
            icon={'done'}
            label={'Set Password'}
            onSubmit={() => onSubmit(submitForm())}
          />
        )}>
        <Form.TextInput
          required
          name='password'
          type={'password'}
          label={'Password'}
          validate={password}
          placeholder={`Enter your new password`}
        />
        <Form.TextInput
          required
          type={'password'}
          name='password_confirm'
          label={'Password Confirm'}
          validate={passwordConfirm}
          placeholder={`confirm your new password`}
        />
      </Form.Fields>
    </FormContain>
  );
};

export default RegisterForm;
